// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"MetaEditContainer-module__wrapper___2kzhf","row":"MetaEditContainer-module__row___22IGr","list":"MetaEditContainer-module__list___2MRN5","controls":"MetaEditContainer-module__controls___3jiox"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MetaEditContainer/MetaEditContainer.module.sass
// module id = 1082
// module chunks = 0